import React from 'react';
import { createProduct, updateResponse, getBranches, getProductLevels, getProductDetailTemplate, getProductsByProductLevelAndBranch, getPrimaryProductById } from "../../api/productapi";
import { connect } from 'react-redux';
import { Redirect } from "react-router-dom";
import { Form, Input, Label, Button, Row, Col, InputGroup } from 'reactstrap';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import CustomDatePicker from '../CustomDatePicker';
import PopupError from '../PopupError';
import PopupConfirmation from '../PopupConfirmation';
import FormValidator from '../FormValidation';
import * as Constants from '../../store/Constants'
import RequiredFieldNotation from '../utils/RequiredFieldNotation';
import feedback from '../utils/feedback';
import InputFeedback from '../utils/InputFeedback';
import '../css/EditCreate.css';
import { getPermission } from '../../api/userapi';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import { Tooltip } from 'reactstrap';

class ProductCreate extends React.Component {

    constructor(props) {
        super(props);
        this.permission = getPermission()
        this.props.route.history.push('/secure/products');
        this.props.route.history.push(this.props.route.match.url);
        this.validator = new FormValidator([
            {
                field: 'displayName',
                method: 'isEmpty',
                validWhen: false,
                message: 'Value is required.'
            },
            {
                field: 'displayName',
                method: (fieldValue, blackList) => {
                    let ret = false
                    if (!fieldValue) {
                        return ret
                    }
                    for (let c of fieldValue) {
                        if (blackList.includes(c)) {
                            ret = true;
                        }
                    }
                    return ret
                },
                args: [Constants.editorExcludeCharacters],
                validWhen: false,
                message: 'Value has invalid characters.'
            },
            {
                field: 'longDescription',
                method: 'isEmpty',
                validWhen: false,
                message: 'Value is required.'
            },
            {
                field: 'longDescription',
                method: (fieldValue, blackList) => {
                    let ret = false
                    if (!fieldValue) {
                        return ret
                    }
                    const text = fieldValue.replace(/(<([^>]+)>)/gi, "")
                    for (let c of text) {
                        if (blackList.includes(c)) {
                            ret = true;
                        }
                    }
                    return ret
                },
                args: [Constants.editorExcludeCharacters],
                validWhen: false,
                message: 'Value has invalid characters.'
            },
            {
                field: 'shortDescription',
                method: 'isEmpty',
                validWhen: false,
                message: 'Value is required.'
            },
            {
                field: 'shortDescription',
                method: (fieldValue, blackList) => {
                    let ret = false
                    if (!fieldValue) {
                        return ret
                    }
                    const text = fieldValue.replace(/(<([^>]+)>)/gi, "")
                    for (let c of text) {
                        if (blackList.includes(c)) {
                            ret = true;
                        }
                    }
                    return ret
                },
                args: [Constants.editorExcludeCharacters],
                validWhen: false,
                message: 'Value has invalid characters.'
            },
            {
                field: 'legalDisclosure',
                method: (fieldValue, blackList) => {
                    let ret = false
                    if (!fieldValue) {
                        return ret
                    }
                    const text = fieldValue.replace(/(<([^>]+)>)/gi, "")
                    for (let c of text) {
                        if (blackList.includes(c)) {
                            ret = true;
                        }
                    }
                    return ret
                },
                args: [Constants.editorExcludeCharacters],
                validWhen: false,
                message: 'Value has invalid characters.'
            },
            {
                field: 'cost',
                method: 'isEmpty',
                validWhen: false,
                message: 'Value is required.'
            },
            {
                field: 'startDate',
                method: this.isBefore,
                validWhen: true,
                message: 'Start date must be before end date.'
            },
            {
                field: 'branchName',
                method: 'isEmpty',
                validWhen: false,
                message: 'Value is required.'
            },
            {
                field: 'productLevelName',
                method: 'isEmpty',
                validWhen: false,
                message: 'Value is required.'
            },
            {
                field: 'towing',
                method: 'isEmpty',
                validWhen: false,
                message: 'Value is required.'
            },
            {
                field: 'entitlements',
                method: 'isEmpty',
                validWhen: false,
                message: 'Value is required.'
            },
            {
                field: 'battery',
                method: 'isEmpty',
                validWhen: false,
                message: 'Value is required.'
            },
            {
                field: 'lockout',
                method: 'isEmpty',
                validWhen: false,
                message: 'Value is required.'
            },
            {
                field: 'fuel',
                method: 'isEmpty',
                validWhen: false,
                message: 'Value is required.'
            },
            {
                field: 'flat',
                method: 'isEmpty',
                validWhen: false,
                message: 'Value is required.'
            },
            {
                field: 'enrollmentFee',
                method: 'isEmpty',
                validWhen: false,
                message: 'Value is required.'
            },
            { field: 'startDate', method: 'isEmpty', validWhen: false, message: 'Value is required.' },
            { field: 'endDate', method: 'isEmpty', validWhen: false, message: 'Value is required.' }
        ])

        this.state = {
            product: {
                displayName: '',
                cost: '',
                endDate: '',
                startDate: '',
                towing: '',
                entitlements: '',
                battery: '',
                mileageException: '',
                flat: '',
                lockout: '',
                fuel: '',
                longDescription: '',
                shortDescription: '',
                legalDisclosure: '',
                branchId: '',
                branchName: '',
                productLevelId: '',
                productLevelName: '',
                enrollmentFee: '',
                costPerAssociate: null,
                isPrimaryProduct: false
            },
            branches: [],
            productLevels: [],
            productDetailTemplate: null,
            cancel: false,
            saved: false,
            error: false,
            tooltipOpen: false,
            errors: [],
            errorMessage: [],
            productId: '',
            openConfirmation: false,
            confirmationMessage: ['Fields have been populated with sample values. Update as you see fit - but required fields do require a value.'],
            labelTypeProduct: [''],
            openProductConfirmation: false,
            confirmationProductMessage: [''],
            isAllowedCreateProduct: true,
            validation: this.validator.valid()
        }

        this.handleCancel = this.handleCancel.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.closeConfirmationModal = this.closeConfirmationModal.bind(this);

        this.openProductConfirmation = false;
        this.isProductPrimary = false;
        this.isVisibleDates = false;
    }

    isBefore = (confirmation, state) => (state.endDate >= confirmation || !state.endDate);
    isAfter = (confirmation, state) => (state.startDate <= confirmation);

    componentDidUpdate(prevProps) {
        //Checks if there is a response on update
        if (this.props.updateResult !== prevProps.updateResult) {
            var result = this.props.updateResult
            //Checks if the response is success or has errors.
            if (result) {
                if (result.data.success) {
                    this.setState(state => ({
                        saved: true,
                        productId: result.data.data.productId
                    }));
                } else {
                    var message = result.data.errors.map(error => error.message);
                    this.setState({
                        error: true,
                        errorMessage: message,
                        errors: result.data.errors
                    });
                }
                this.props.updateResponse("");
            }
        }
    }

    componentDidMount() {
        this.props.getBranches(function (result, _this) { _this.getData(result, _this) }, this, this.permission.isOwner)
        this.props.getProductLevels(function (result, _this) { _this.getLevelsData(result, _this) }, this)
        this.setState({
            loading: true
        })
    }

    componentWillUnmount() {
        if (this.removeMessageEventListener === true)
            window.removeEventListener("message", this.messageHandler)
    }

    toggleTooltip = () => {
        this.setState({
            tooltipOpen: !this.state.tooltipOpen
        });
    }

    renderBranchNames() {
        let branches = this.state.branches;
        return branches.map((branch, index) => {
            return (
                <option value={branch.branchId} key={index}>{branch.name}</option>
            );
        });
    }

    renderProductLevels() {
        let productLevels = this.state.productLevels;
        return productLevels.map((productLevel, index) => {
            return (
                <option value={productLevel.productLevelId} key={index}>{productLevel.productLevelName}</option>
            );
        });
    }

    getData(data, _this) {
        if (data) {
            let branches = data.data.data;
            _this.setState({
                branches: branches,
                loading: false
            }, () => {
                if (branches.length === 1) {
                    const branch = branches[0];
                    _this.setState(prevState => ({
                        product: {
                            ...prevState.product,
                            branchId: branch.branchId,
                            branchName: branch.name
                        }
                    }));
                }
            })
        }
    }

    getLevelsData(data, _this) {
        if (data) {
            let productLevels = data.data.data;
            _this.setState({
                productLevels: productLevels,
                loading: false
            })
        }
    }

    getDetailTemplate(data, _this) {
        if (data) {
            let productDetailTemplate = data.data.data;
            _this.setState((prevState) => ({
                product: {
                    ...prevState.product,
                    cost: productDetailTemplate.cost,
                    towing: productDetailTemplate.towing,
                    entitlements: productDetailTemplate.entitlements,
                    battery: productDetailTemplate.battery,
                    mileageException: productDetailTemplate.mileageException,
                    flat: productDetailTemplate.flat,
                    lockout: productDetailTemplate.lockout,
                    fuel: productDetailTemplate.fuel,
                    longDescription: productDetailTemplate.longDescription,
                    shortDescription: productDetailTemplate.shortDescription,
                    legalDisclosure: productDetailTemplate.legalDisclosure,
                    enrollmentFee: productDetailTemplate.enrollmentFee,
                    costPerAssociate: productDetailTemplate.costPerAssociate,
                    freeAssociatesAllowedNumber: productDetailTemplate.freeAssociatesAllowedNumber
                },
                productDetailTemplate: productDetailTemplate,
                openConfirmation: true,
                loading: false,
            }));
        }
    }

    handleFormSubmit = (event, productOption) => {
        event.preventDefault();
        if (!this.state.isAllowedCreateProduct) {
            if (this.state.confirmationProductMessage > '') this.setState({ openProductConfirmation: true });
        } else {

            var updVal = this.state.product;
            updVal.displayName = updVal.displayName.trim()
            updVal.startDate = document.getElementById("startDate") != null ? document.getElementById("startDate").value : null;
            updVal.endDate = document.getElementById("endDate") != null ? document.getElementById("endDate").value : null;
            updVal.isPrimaryProduct = this.isProductPrimary;

            this.setState({ product: updVal }, () => {
                const validation = this.validator.validate(this.state.product);
                this.setState({ validation });
                this.submitted = true;
                if (validation.isValid) {
                    // handle actual form submission here
                    this.props.createProduct(updVal, productOption);
                }
            });
        }
    }

    //Redirects to product list
    handleCancel = () => {
        this.setState({
            cancel: true
        })
    }

    isInvalid(e) {
        var input = e.target;
        if (input.value) { input.classList.remove("is-invalid"); }
        else { input.classList.add("is-invalid"); }
    }

    //Closes the popup when the X is clicked or click outside the modal.
    closeModal() {
        this.setState({ error: false });
    }

    closeConfirmationModal() {
        this.setState({ openConfirmation: false });
    }

    closeProductConfirmationModal = () => {
        if (!this.state.isAllowedCreateProduct) {
            this.handleCancel();
        } else {
            this.setState({ openProductConfirmation: false });
        }
    }

    messageHandler = event => {
        if (event.origin === this.props.publicSiteBaseUrl && event.data === 'PreviewProduct')
            event.source.postMessage({ ...this.state.product }, event.origin)
    }

    handleSubmit = () => {
        event.preventDefault();
        window.open(`${this.props.publicSiteBaseUrl}/preview-membership/`, '_blank').focus();
        window.addEventListener("message", this.messageHandler)
        this.removeMessageEventListener = true
    }

    handleProductLevelChange(e) {
        const text = e.target.options[e.target.selectedIndex].text;
        const value = e.target.value;
        this.props.getProductDetailTemplate(function (result, _this) { _this.getDetailTemplate(result, _this) }, this, value)
        this.setState(prevState => ({ product: { ...prevState.product, productLevelId: value, productLevelName: text } }))
        const product = this.state.product
        this.handleProductPrimary(value, product.branchId);
    }

    handleProductPrimary(productLevelId, branchId) {
        const product = this.state.product
        productLevelId = productLevelId == '' ? product.productLevelId : productLevelId;
        branchId = branchId == '' ? product.branchId : branchId;
        this.setState({ confirmationProductMessage: '' });

        if (productLevelId > '' && branchId > '') {
            getProductsByProductLevelAndBranch(productLevelId, branchId)
                .then((res) => {
                    const productLevelBranch = res.data.data;
                    if (productLevelBranch != null) {
                        if (productLevelBranch.length > 0) {
                            this.handlePrimaryProductById(productLevelId, branchId);

                            const primaryProduct = productLevelBranch.find(x => x.isPrimaryProduct == true);
                            const alternateProduct = productLevelBranch.find(x => x.isPrimaryProduct == false);

                            if (primaryProduct != null && alternateProduct != null) {
                                this.setState({ isAllowedCreateProduct: false });
                                this.setState({ confirmationProductMessage: `You won\'t be able to save this product since ${this.state.product.productLevelName} for ${this.state.product.branchName} already have a primary and alternate product.` });
                                this.setState({ openProductConfirmation: true });
                                this.isVisibleDates = true;
                                this.isProductPrimary = false
                            } else {
                                if (primaryProduct != null) {
                                    this.isVisibleDates = true;
                                    this.isProductPrimary = false
                                    this.setState({ labelTypeProduct: 'The product to be created will be alternate.' })
                                    this.setState({ confirmationProductMessage: `A primary ${this.state.product.productLevelName} product exists for ${this.state.product.branchName} this product will be created as the alternate product. The product details have been updated to match the existing Primary product\'s details.  Please note that Start and End Dates are required for Alternate Products.` });
                                    this.setState({ openProductConfirmation: true });
                                } else {
                                    this.isVisibleDates = false;
                                    this.isProductPrimary = true;
                                    this.setState({ labelTypeProduct: 'The product to be created will be primary.' });
                                }
                            }

                        } else {
                            this.isVisibleDates = false;
                            this.isProductPrimary = true;
                            this.setState({ labelTypeProduct: 'The product to be created will be primary.' });
                        }
                    } else {
                        this.isVisibleDates = false;
                        this.isProductPrimary = true;
                        this.setState({ labelTypeProduct: 'The product to be created will be primary.' });
                    }
                }).catch((err) => {
                    this.isVisibleDates = false;
                });
        }
    }
    setPrimaryProduct(productPrimary, cleanData) {
        this.setState(prevState => ({
            product: {
                ...prevState.product, cost: cleanData ? '' : productPrimary.cost,
                costPerAssociate: cleanData ? '' : productPrimary.costPerAssociate,
                freeAssociatesAllowedNumber: cleanData ? '' : productPrimary.freeAssociatesAllowedNumber,
                name: cleanData ? '' : productPrimary.name,
                displayName: cleanData ? '' : productPrimary.displayName,
                shortDescription: cleanData ? '' : productPrimary.shortDescription,
                longDescription: cleanData ? '' : productPrimary.longDescription,
                legalDisclosure: cleanData ? '' : productPrimary.legalDisclosure,
                towing: cleanData ? '' : productPrimary.towing,
                entitlements: cleanData ? '' : productPrimary.entitlements,
                battery: cleanData ? '' : productPrimary.battery,
                mileageException: cleanData ? '' : productPrimary.mileageException,
                flat: cleanData ? '' : productPrimary.flat,
                lockout: cleanData ? '' : productPrimary.lockout,
                fuel: cleanData ? '' : productPrimary.fuel,
                branchName: cleanData ? '' : productPrimary.branchName,
                enrollmentFee: cleanData ? '' : productPrimary.enrollmentFee,
                productStatus: cleanData ? '' : productPrimary.productStatus,
                branchIanaTimeZoneId: cleanData ? '' : productPrimary.branchIanaTimeZoneId,
            }
        }))
    }
    handlePrimaryProductById(productLevelId, branchId) {
        getPrimaryProductById(productLevelId, branchId)
            .then((res) => {
                const productPrimary = res.data.data;
                this.setPrimaryProduct(productPrimary, true);
                this.setPrimaryProduct(productPrimary, false);
            }).catch((err) => {
                this.isVisibleDates = false;
            });
    }

    render() {
        const product = this.state.product;

        //Redirects to product when canceled
        if (this.state.cancel) {
            return <Redirect
                to={{
                    pathname: `/secure/products`,
                }}
            />;
        }

        //Redirects to products when succesfully saved
        if (this.state.saved) {
            return <Redirect
                to={{
                    pathname: `/secure/productEdit/${this.state.productId}`,
                    state: { productId: this.state.productId }
                }}
            />;
        }

        let validation = this.submitted ?                         // if the form has been submitted at least once
            this.validator.validate(this.state.product) :   // then check validity every time we render
            this.state.validation                   // otherwise just use what's in state

        if (document.querySelector('.nativeDatePicker')) document.querySelector('.nativeDatePicker').style.display = 'none';
        return (
            <div className="card">

                <PopupError
                    open={this.state.error}
                    onClose={this.closeModal}
                    onClick={this.closeModal}
                    onSubmit={this.handleFormSubmit.bind(this)}
                    errorMessage={this.state.errorMessage}
                    errors={this.state.errors}
                />

                <PopupConfirmation
                    open={this.state.openConfirmation}
                    onClose={this.closeConfirmationModal}
                    onClick={this.closeConfirmationModal}
                    errorMessage={this.state.confirmationMessage}
                />

                <PopupConfirmation
                    open={this.state.openProductConfirmation}
                    onClose={this.closeProductConfirmationModal}
                    onClick={this.closeProductConfirmationModal}
                    errorMessage={this.state.confirmationProductMessage}
                />

                <div className="card-header text-center"> Add Product</div>
                <div className="card-body fs-12">
                    <Form>
                        <RequiredFieldNotation />
                        <div className="row">
                            <div className="col-md-12">
                                <Col>
                                    <Row>
                                        <Col className={`${validation.productLevelName.isInvalid && this.submitted ? 'has-error-product' : ''}`}>
                                            <Label htmlFor='productLevelIdSelect' className="required-hint mt-4"><strong>Product Level</strong></Label>
                                            <div className={this.state.readOnly ? 'select-disabled' : 'select product-select'}>
                                                <select
                                                    id="productLevelIdSelect"
                                                    className={`input-editable-product form-control ${product.productLevelId === '' ? 'default-option' : ''}`}
                                                    value={product.productLevelId}
                                                    required={this.submitted}
                                                    title=""
                                                    disabled={this.state.readOnly}
                                                    onChange={(e) => this.handleProductLevelChange(e)}
                                                >
                                                    <option value="">Select one...</option>
                                                    {this.renderProductLevels()}
                                                </select>
                                            </div>
                                            <span className="help-block">{validation.productLevelName.message}</span>
                                        </Col>
                                        <Col className={`${validation.branchName.isInvalid && this.submitted ? 'has-error-product' : ''}`}>
                                            <Label htmlFor='branchIdSelect' className="required-hint mt-4"><strong>Branch</strong></Label>
                                            <div className={this.state.readOnly ? 'select-disabled' : 'select product-select'}>
                                                <select
                                                    id="branchIdSelect"
                                                    className={`input-editable-product form-control ${product.branchId === '' ? 'default-option' : ''}`}
                                                    value={product.branchId}
                                                    required={this.submitted}
                                                    title=""
                                                    disabled={this.state.readOnly}
                                                    onChange={(e) => {
                                                        const text = e.target.options[e.target.selectedIndex].text;
                                                        const value = e.target.value;
                                                        this.setState(prevState => ({ product: { ...prevState.product, branchId: value, branchName: text } }))
                                                        this.handleProductPrimary("", value);
                                                    }}
                                                >
                                                    <option value="">Select one...</option>
                                                    {this.renderBranchNames()}
                                                </select>
                                            </div>
                                            <span className="help-block">{validation.branchName.message}</span>
                                        </Col>
                                        <Col className={`${validation.displayName.isInvalid && this.submitted ? 'has-error-product' : ''}`}>
                                            <Label htmlFor='productDisplayName' className="required-hint mt-4"><strong>Product-Branch Display Name</strong></Label>
                                            <Input readOnly={this.state.readOnly}
                                                type="input"
                                                className={this.state.readOnly ? '' : 'input-editable-product'}
                                                maxLength="150"
                                                id='productDisplayName'
                                                required={this.submitted}
                                                title=""
                                                value={product.displayName}
                                                onKeyDown={e => {
                                                    if (Constants.editorExcludeCharacters.indexOf(e.key) >= 0) {
                                                        e.preventDefault()
                                                    }
                                                }}
                                                onChange={e => {
                                                    this.isInvalid(e)
                                                    const value = e.target.value
                                                    this.setState(prevState => ({ product: { ...prevState.product, displayName: value } }))
                                                }} />
                                            <InputFeedback feedbackText={feedback.productDisplayName} id='productDisplayName' />
                                            <span className="help-block">{validation.displayName.message}</span>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col>
                                        </Col>
                                        <Col>
                                            <p className='primary-product mt-4'>{this.state.isAllowedCreateProduct ? this.state.labelTypeProduct : ''} </p>
                                        </Col>
                                        <Col>
                                        </Col>
                                    </Row>
                                </Col>
                            </div>
                            <div className="col-md-12">
                                <Col className={`${validation.shortDescription.isInvalid && this.submitted ? 'has-error-product' : ''}`}>
                                    <div className="required-hint inline-label div-label-margin mt-4"><strong>Short Description</strong></div>
                                    <ReactQuill
                                        className={this.state.readOnly ? 'reactquill-field-smaller' : 'reactquill-field-smaller widget'}
                                        theme="snow"
                                        id='productShortDescription'
                                        modules={{
                                            toolbar: Constants.editorToolbar
                                        }}
                                        preserveWhitespace={true}
                                        value={product.shortDescription}
                                        onKeyDown={e => {
                                            if (Constants.editorExcludeCharacters.indexOf(e.key) >= 0) {
                                                e.preventDefault()
                                            }
                                        }}
                                        onChange={value => {
                                            if (value.length < 2000) {
                                                this.setState(prevState => ({ product: { ...prevState.product, shortDescription: value } }))
                                            } else {
                                                this.setState(prevState => ({ product: { ...prevState.product } }))
                                            }
                                        }}
                                    />
                                    <InputFeedback feedbackText={feedback.productShortDescription} id='productShortDescription' />
                                    <span className="help-block">{validation.shortDescription.message}</span>
                                </Col>
                                <Col className={`${validation.longDescription.isInvalid && this.submitted ? 'has-error-product' : ''}`}>
                                    <div className="required-hint inline-label div-label-margin mt-4"><strong>Long Description</strong></div>
                                    <ReactQuill
                                        className={this.state.readOnly ? 'reactquill-field' : 'reactquill-field widget'}
                                        theme="snow"
                                        id='productLongDescription'
                                        modules={{
                                            toolbar: Constants.editorToolbar
                                        }}
                                        preserveWhitespace={true}
                                        value={product.longDescription}
                                        onKeyDown={e => {
                                            if (Constants.editorExcludeCharacters.indexOf(e.key) >= 0) {
                                                e.preventDefault()
                                            }
                                        }}
                                        onChange={value => {
                                            if (value.length < 2000) {
                                                this.setState(prevState => ({ product: { ...prevState.product, longDescription: value } }))
                                            }
                                        }}
                                    />
                                    <InputFeedback feedbackText={feedback.productLongDescription} id='productLongDescription' />
                                    <span className="help-block">{validation.longDescription.message}</span>
                                </Col>
                                <Col className={`${validation.legalDisclosure.isInvalid && this.submitted ? 'has-error-product' : ''}`}>
                                    <div className="required-hint inline-label div-label-margin mt-4"><strong>Legal Disclosure</strong></div>
                                    <ReactQuill
                                        className={this.state.readOnly ? 'reactquill-field-smaller' : 'reactquill-field-smaller widget'}
                                        theme="snow"
                                        id='productLegalDisclosure'
                                        modules={{
                                            toolbar: Constants.editorToolbar
                                        }}
                                        preserveWhitespace={true}
                                        value={product.legalDisclosure}
                                        onKeyDown={e => {
                                            if (Constants.editorExcludeCharacters.indexOf(e.key) >= 0) {
                                                e.preventDefault()
                                            }
                                        }}
                                        onChange={value => {
                                            this.setState(prevState => ({ product: { ...prevState.product, legalDisclosure: value } }))
                                        }}
                                    />
                                    <InputFeedback feedbackText={feedback.productLegalDisclosure} id='productLegalDisclosure' />
                                    <span className="help-block">{validation.legalDisclosure.message}</span>
                                </Col>
                            </div>
                            <div className="col-md-6">
                                <Col>
                                    <Row form>
                                        <Col className={`${validation.towing.isInvalid && this.submitted ? 'has-error-product' : ''}`} style={{ marginBottom: 17 }}>
                                            <Label htmlFor='towing' className="required-hint mt-4"><strong>Towing Miles</strong></Label>
                                            <Input readOnly={this.state.readOnly}
                                                id="towing"
                                                type="input"
                                                maxLength="2000"
                                                className={this.state.readOnly ? '' : 'input-editable-product'}
                                                value={product.towing}
                                                onChange={(e) => { var x = product; x.towing = e.target.value; this.setState({ product: x }) }} />
                                            <span className="help-block">{validation.towing.message}</span>
                                        </Col>
                                        <Col className={`${validation.entitlements.isInvalid && this.submitted ? 'has-error-product' : ''}`}>
                                            <Label htmlFor='entitlements' className="required-hint mt-4"><strong>Service Calls per Year</strong></Label>
                                            <Input readOnly={this.state.readOnly}
                                                id="entitlements"
                                                type="input"
                                                maxLength="255"
                                                className={this.state.readOnly ? '' : 'input-editable-product'}
                                                value={product.entitlements}
                                                onChange={(e) => { var x = product; x.entitlements = e.target.value; this.setState({ product: x }) }} />
                                            <span className="help-block">{validation.entitlements.message}</span>
                                        </Col>
                                    </Row>
                                </Col>
                                <Col className={`${validation.battery.isInvalid && this.submitted ? 'has-error-product' : ''}`}>
                                    <Label htmlFor='battery' className="required-hint mt-4"><strong>Battery Service</strong></Label>
                                    <Input readOnly={this.state.readOnly}
                                        id="battery"
                                        style={{ height: 52 }}
                                        type="textarea"
                                        className={this.state.readOnly ? '' : 'input-editable-product'}
                                        maxLength="255"
                                        onChange={(e) => { var x = product; x.battery = e.target.value; this.setState({ product: x }) }}
                                        value={product.battery} />
                                    <span className="help-block">{validation.battery.message}</span>
                                </Col>
                                <Col className={`${validation.lockout.isInvalid && this.submitted ? 'has-error-product' : ''}`}>
                                    <Label htmlFor='lockout' className="required-hint mt-4"><strong>Lockout Service</strong></Label>
                                    <Input readOnly={this.state.readOnly}
                                        id="lockout"
                                        style={{ height: 52 }}
                                        type="textarea"
                                        className={this.state.readOnly ? '' : 'input-editable-product'}
                                        maxLength="255"
                                        onChange={(e) => { var x = product; x.lockout = e.target.value; this.setState({ product: x }) }}
                                        value={product.lockout} />
                                    <span className="help-block">{validation.lockout.message}</span>
                                </Col>
                            </div>
                            <div className="col-md-6">
                                <Col>
                                    <Label htmlFor='mileageException' className="mt-4"><strong>Towing Miles Exception</strong></Label>
                                    <Input readOnly={this.state.readOnly}
                                        id="mileageException"
                                        style={{ height: 52 }}
                                        type="textarea"
                                        maxLength="255"
                                        className={this.state.readOnly ? '' : 'input-editable-product'}
                                        value={product.mileageException}
                                        onChange={(e) => { var x = product; x.mileageException = e.target.value; this.setState({ product: x }) }} />
                                    <span className="help-block"></span>
                                </Col>
                                <Col className={`${validation.flat.isInvalid && this.submitted ? 'has-error-product' : ''}`}>
                                    <Label htmlFor='flat' className="required-hint mt-4"><strong>Flat Tire Change</strong></Label>
                                    <Input readOnly={this.state.readOnly}
                                        id="flat"
                                        style={{ height: 52 }}
                                        type="textarea"
                                        className={this.state.readOnly ? '' : 'input-editable-product'}
                                        maxLength="255"
                                        onChange={(e) => { var x = product; x.flat = e.target.value; this.setState({ product: x }) }}
                                        value={product.flat} />
                                    <span className="help-block">{validation.flat.message}</span>
                                </Col>
                                <Col className={`${validation.fuel.isInvalid && this.submitted ? 'has-error-product' : ''}`}>
                                    <Label htmlFor='fuel' className="required-hint mt-4"><strong>Fuel Delivery</strong></Label>
                                    <Input readOnly={this.state.readOnly}
                                        id="fuel"
                                        style={{ height: 52 }}
                                        type="textarea"
                                        className={this.state.readOnly ? '' : 'input-editable-product'}
                                        maxLength="255"
                                        onChange={(e) => { var x = product; x.fuel = e.target.value; this.setState({ product: x }) }}
                                        value={product.fuel} />
                                    <span className="help-block">{validation.fuel.message}</span>
                                </Col>
                            </div>
                            <div className="col-md-12">
                                <hr style={{ border: '1.4px solid #4798d2', marginTop: '1.5rem !important', marginBottom: 0, width: '97%' }} />
                            </div>
                            <div className="col-md-6">
                                <Col>
                                    <Row>
                                        <Col className={`${validation.cost.isInvalid && this.submitted ? 'has-error-product-currency' : ''}`}>
                                            <Label htmlFor='productCost' className="required-hint mt-4"><strong>Price</strong></Label>
                                            <InputGroup>
                                                <div className="input-group-prepend">
                                                    <span className="input-group-text currency-span">
                                                        $
                                                    </span>
                                                </div>
                                                <Input readOnly={this.state.readOnly}
                                                    type="number"
                                                    step=".01"
                                                    min="0"
                                                    id='productCost'
                                                    className={this.state.readOnly ? '' : 'input-editable-product noborder-left'}
                                                    maxLength="150"
                                                    required={this.submitted}
                                                    title=""
                                                    value={product.cost}
                                                    onBlur={(e) => { e.target.value = parseFloat(e.target.value).toFixed(2); var x = product; x.cost = e.target.value; this.setState({ product: x }) }}
                                                    onChange={(e) => { this.isInvalid(e); var x = product; x.cost = e.target.value; this.setState({ product: x }) }} />
                                                <InputFeedback feedbackText={feedback.productCost} id='productCost' />
                                            </InputGroup>
                                            <span className="help-block">{validation.cost.message}</span>
                                        </Col>
                                        <Col className={`${validation.enrollmentFee.isInvalid && this.submitted ? 'has-error-product-currency' : ''}`}>
                                            <Label htmlFor='enrollmentFee' className="required-hint mt-4"><strong>Enrollment Fee</strong></Label>
                                            <InputGroup>
                                                <div className="input-group-prepend">
                                                    <span className="input-group-text currency-span">
                                                        $
                                                    </span>
                                                </div>
                                                <Input readOnly={this.state.readOnly}
                                                    id="enrollmentFee"
                                                    type="number"
                                                    step=".01"
                                                    min="0"
                                                    className={this.state.readOnly ? '' : 'input-editable-product noborder-left'}
                                                    maxLength="150"
                                                    value={product.enrollmentFee}
                                                    onBlur={(e) => { e.target.value = parseFloat(e.target.value).toFixed(2); var x = product; x.enrollmentFee = e.target.value; this.setState({ product: x }) }}
                                                    onChange={(e) => { var x = product; x.enrollmentFee = e.target.value; this.setState({ product: x }) }} />
                                            </InputGroup>
                                            <span className="help-block">{validation.enrollmentFee.message}</span>
                                        </Col>
                                    </Row>
                                </Col>
                            </div>
                            <div className="col-md-6">
                                <Col style={{ marginBottom: 50 }}>
                                    <Row form>
                                        <Col>
                                            <Label htmlFor='costPerAssociate' className="mt-4">
                                                <strong>
                                                    Price per Associate{' '}
                                                    <FontAwesomeIcon
                                                        id="priceInfo"
                                                        icon={faInfoCircle}
                                                        className="text-info purple-tooltip"
                                                    />
                                                </strong>
                                            </Label>
                                            <Tooltip
                                                placement="top"
                                                isOpen={this.state.tooltipOpen}
                                                target="priceInfo"
                                                toggle={this.toggleTooltip}
                                            >
                                                To disable Associates on this product, set price to $0.
                                            </Tooltip>
                                            <InputGroup>
                                                <div className="input-group-prepend">
                                                    <span className="input-group-text currency-span">
                                                        $
                                                    </span>
                                                </div>
                                                <Input readOnly={this.state.readOnly}
                                                    id="costPerAssociate"
                                                    type="number"
                                                    className={this.state.readOnly ? '' : 'input-editable-product noborder-left'}
                                                    maxLength="150"
                                                    step="0.01"
                                                    min="0"
                                                    title=""
                                                    value={product.costPerAssociate}
                                                    onBlur={(e) => { e.target.value = parseFloat(e.target.value).toFixed(2); var x = product; x.costPerAssociate = e.target.value; this.setState({ product: x }) }}
                                                    onChange={(e) => { var x = product; x.costPerAssociate = e.target.value; this.setState({ product: x }) }} />
                                            </InputGroup>
                                        </Col>
                                        <Col>
                                            <Label htmlFor='freeAss' className="required-hint mt-4"><strong>Free Associates</strong></Label>
                                            <div className={this.state.readOnly ? 'select-disabled' : 'select product-select'}>
                                                <select
                                                    id="freeAss"
                                                    name="freeAss"
                                                    className={this.state.readOnly ? 'form-control' : 'input-editable-product form-control'}
                                                    value={product.freeAssociatesAllowedNumber}
                                                    onChange={(e) => { var x = product; x.freeAssociatesAllowedNumber = e.target.value; this.setState({ product: x }) }}
                                                    readOnly={this.state.readOnly}>
                                                    <option>0</option>
                                                    <option>1</option>
                                                    <option>2</option>
                                                    <option>3</option>
                                                    <option>4</option>
                                                    <option>5</option>
                                                </select>
                                            </div>
                                        </Col>
                                    </Row>
                                </Col>
                            </div>
                            <div className="col-md-12">
                                <hr style={{ border: '1.4px solid #4798d2', marginTop: 0, marginBottom: 0, width: '97%' }} />
                            </div>
                            <div className="col-md-6">
                                <Col>
                                    {!this.state.readOnly && this.isVisibleDates && <Row form>
                                        <Col className={`${validation.startDate.isInvalid && this.submitted ? 'has-error-product' : ''}`}>
                                            <Label htmlFor='startDate' className="required-hint mt-4"><strong>Start Date</strong></Label>
                                            <CustomDatePicker
                                                id="startDate"
                                                readOnly={this.state.readOnly}
                                                className="input-date"
                                                defValue={!product.startDate ? "" : product.startDate.substring(0, 10)}
                                                label="Start Date"
                                                overlayClass="location-datepicker-overlay"
                                            />
                                            <InputFeedback feedbackText={feedback.productDate} id='startDate' />
                                            <span className="help-block-calendar">{validation.startDate.message}</span>
                                        </Col>
                                        <Col>
                                            <Label htmlFor='endDate' className="required-hint mt-4"><strong>End Date</strong></Label>
                                            <CustomDatePicker
                                                id="endDate"
                                                readOnly={this.state.readOnly}
                                                className="input-date"
                                                defValue={!product.endDate ? "" : product.endDate.substring(0, 10)}
                                                label="End Date"
                                                overlayClass="location-datepicker-overlay"
                                            />
                                            <InputFeedback feedbackText={feedback.productDate} id='endDate' />
                                            <span className="help-block-calendar">{validation.endDate.message}</span>
                                        </Col>
                                    </Row>}

                                    {this.state.readOnly && this.isVisibleDates &&
                                        <Row form>
                                            <Col>
                                                <Label htmlFor='_startDate' className="required-hint mt-4"><strong>Start Date</strong></Label>
                                                <Input
                                                    id="_startDate"
                                                    readOnly={true}
                                                    className=''
                                                    value={this.state._startDate}>
                                                </Input>

                                            </Col>
                                            <Col>
                                                <Label htmlFor='_endDate' className="required-hint mt-4"><strong>End Date</strong></Label>
                                                <Input
                                                    id="_endDate"
                                                    readOnly={true}
                                                    className=''
                                                    value={this.state._endDate}>
                                                </Input>
                                            </Col>
                                        </Row>
                                    }
                                </Col>
                            </div>
                            <div className="col-md-6">
                                <Col className="text-right float-bottom d-flex flex-wrap justify-content-end flex-row">
                                    <Button onClick={this.handleSubmit.bind(this)} type="submit" className={!this.props.publicSiteBaseUrl ? 'd-none' : 'mail-btn ml-2'}>PREVIEW</Button>
                                    <Button onClick={this.handleCancel.bind(this)} className="mx-2 cancel-btn">CANCEL</Button>
                                    <Button onClick={this.handleFormSubmit.bind(this)} type="submit" color="primary" className={this.state.readOnly ? 'd-none' : 'mail-btn ml-1'}>SAVE</Button>
                                </Col>
                            </div>
                        </div>
                    </Form>
                </div>
            </div>
        );
    }
}
export default connect(
    state => {
        return {
            updateResult: state.data.updateResult,
            branches: state.data.branches,
            productLevels: state.data.productLevels,
            publicSiteBaseUrl: state.data.settings.value && state.data.settings.value.publicSiteBaseUrl,
        }
    },
    dispatch => ({
        getBranches: (callback, context, onlyActive) => { dispatch(getBranches(callback, context, onlyActive)) },
        getProductDetailTemplate: (callback, context, id) => { dispatch(getProductDetailTemplate(callback, context, id)) },
        getProductLevels: (callback, context) => { dispatch(getProductLevels(callback, context)) },
        createProduct: (product, productOption) => { dispatch(createProduct(product, productOption)) },
        updateResponse: (response) => { dispatch(updateResponse(response)) }
    }
    )
)(ProductCreate);